import { EVENT_MANAGER_PLUGINS } from '@angular/platform-browser';
import { Injectable, NgZone, NgModule, Inject } from '@angular/core';
import { EMPTY, concat, defer } from 'rxjs';
import { takeWhile } from 'rxjs/operators';

/**
 * @fileoverview added by tsickle
 * Generated from: utils/dasharize.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} camel
 * @return {?}
 */
import * as ɵngcc0 from '@angular/core';
function dasharize(camel) {
    return camel.replace(/[a-z][A-Z]/g, (/**
     * @param {?} letterLetter
     * @return {?}
     */
    letterLetter => {
        return `${letterLetter[0]}-${letterLetter[1].toLowerCase()}`;
    }));
}

/**
 * @fileoverview added by tsickle
 * Generated from: plugins/abstract.plugin.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
class AbstractEventPlugin {
    /**
     * @param {?} event
     * @return {?}
     */
    supports(event) {
        return event.includes(this.modifier);
    }
    /**
     * @param {?} _element
     * @param {?} _event
     * @param {?} _handler
     * @return {?}
     */
    addGlobalEventListener(_element, _event, _handler) {
        throw new Error(`Global event targets are not supported by ${this.modifier} plugin`);
    }
    /**
     * @protected
     * @param {?} event
     * @return {?}
     */
    unwrap(event) {
        return event
            .split('.')
            .filter((/**
         * @param {?} v
         * @return {?}
         */
        v => !this.modifier.includes(v)))
            .join('.');
    }
}
if (false) {
    /**
     * @type {?}
     * @protected
     */
    AbstractEventPlugin.prototype.modifier;
    /** @type {?} */
    AbstractEventPlugin.prototype.manager;
    /**
     * @abstract
     * @param {?} element
     * @param {?} event
     * @param {?} handler
     * @return {?}
     */
    AbstractEventPlugin.prototype.addEventListener = function (element, event, handler) { };
}

/**
 * @fileoverview added by tsickle
 * Generated from: plugins/bind.plugin.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BindEventPlugin extends AbstractEventPlugin {
    constructor() {
        super(...arguments);
        this.modifier = '$';
    }
    /**
     * @param {?} element
     * @param {?} event
     * @return {?}
     */
    addEventListener(element, event) {
        element[event] = element[event] || EMPTY;
        /** @type {?} */
        const method = this.getMethod(element, event);
        /** @type {?} */
        const zone$ = this.manager.getZone().onStable;
        /** @type {?} */
        const sub = concat(zone$.pipe(takeWhile((/**
         * @return {?}
         */
        () => element[event] === EMPTY))), defer((/**
         * @return {?}
         */
        () => element[event]))).subscribe(method);
        return (/**
         * @return {?}
         */
        () => sub.unsubscribe());
    }
    /**
     * @private
     * @param {?} element
     * @param {?} event
     * @return {?}
     */
    getMethod(element, event) {
        const [, key, value, unit = ''] = event.split('.');
        if (event.endsWith('.attr')) {
            return (/**
             * @param {?} v
             * @return {?}
             */
            v => v === null
                ? element.removeAttribute(key)
                : element.setAttribute(key, String(v)));
        }
        if (key === 'class') {
            return (/**
             * @param {?} v
             * @return {?}
             */
            v => element.classList.toggle(value, !!v));
        }
        if (key === 'style') {
            return (/**
             * @param {?} v
             * @return {?}
             */
            v => element.style.setProperty(dasharize(value), `${v}${unit}`));
        }
        return (/**
         * @param {?} v
         * @return {?}
         */
        v => (element[key] = v));
    }
}
BindEventPlugin.ɵfac = /*@__PURE__*/ function () { let ɵBindEventPlugin_BaseFactory; return function BindEventPlugin_Factory(t) { return (ɵBindEventPlugin_BaseFactory || (ɵBindEventPlugin_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(BindEventPlugin)))(t || BindEventPlugin); }; }();
BindEventPlugin.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: BindEventPlugin, factory: BindEventPlugin.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BindEventPlugin, [{
        type: Injectable
    }], null, null); })();
if (false) {
    /**
     * @type {?}
     * @protected
     */
    BindEventPlugin.prototype.modifier;
}

/**
 * @fileoverview added by tsickle
 * Generated from: plugins/options.plugin.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class OptionsEventPlugin extends AbstractEventPlugin {
    constructor() {
        super(...arguments);
        this.modifier = 'capture.once.passive';
    }
    /**
     * @param {?} event
     * @return {?}
     */
    supports(event) {
        return event.includes('.') && !this.unwrap(event).includes('.');
    }
    /**
     * @param {?} element
     * @param {?} event
     * @param {?} handler
     * @return {?}
     */
    addEventListener(element, event, handler) {
        element.addEventListener(this.unwrap(event), handler, {
            once: event.includes('.once'),
            passive: event.includes('.passive'),
            capture: event.includes('.capture'),
        });
        return (/**
         * @return {?}
         */
        () => element.removeEventListener(this.unwrap(event), handler));
    }
}
OptionsEventPlugin.ɵfac = /*@__PURE__*/ function () { let ɵOptionsEventPlugin_BaseFactory; return function OptionsEventPlugin_Factory(t) { return (ɵOptionsEventPlugin_BaseFactory || (ɵOptionsEventPlugin_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(OptionsEventPlugin)))(t || OptionsEventPlugin); }; }();
OptionsEventPlugin.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: OptionsEventPlugin, factory: OptionsEventPlugin.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OptionsEventPlugin, [{
        type: Injectable
    }], null, null); })();
if (false) {
    /**
     * @type {?}
     * @protected
     */
    OptionsEventPlugin.prototype.modifier;
}

/**
 * @fileoverview added by tsickle
 * Generated from: plugins/prevent.plugin.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PreventEventPlugin extends AbstractEventPlugin {
    constructor() {
        super(...arguments);
        this.modifier = '.prevent';
    }
    /**
     * @param {?} element
     * @param {?} event
     * @param {?} handler
     * @return {?}
     */
    addEventListener(element, event, handler) {
        /** @type {?} */
        const wrapped = (/**
         * @param {?} event
         * @return {?}
         */
        (event) => {
            event.preventDefault();
            handler(event);
        });
        return this.manager.addEventListener(element, this.unwrap(event), wrapped);
    }
    /**
     * @param {?} element
     * @param {?} event
     * @param {?} handler
     * @return {?}
     */
    addGlobalEventListener(element, event, handler) {
        /** @type {?} */
        const wrapped = (/**
         * @param {?} event
         * @return {?}
         */
        (event) => {
            event.preventDefault();
            handler(event);
        });
        return this.manager.addGlobalEventListener(element, this.unwrap(event), wrapped);
    }
}
PreventEventPlugin.ɵfac = /*@__PURE__*/ function () { let ɵPreventEventPlugin_BaseFactory; return function PreventEventPlugin_Factory(t) { return (ɵPreventEventPlugin_BaseFactory || (ɵPreventEventPlugin_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(PreventEventPlugin)))(t || PreventEventPlugin); }; }();
PreventEventPlugin.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PreventEventPlugin, factory: PreventEventPlugin.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PreventEventPlugin, [{
        type: Injectable
    }], null, null); })();
if (false) {
    /**
     * @type {?}
     * @protected
     */
    PreventEventPlugin.prototype.modifier;
}

/**
 * @fileoverview added by tsickle
 * Generated from: plugins/self.plugin.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SelfEventPlugin extends AbstractEventPlugin {
    constructor() {
        super(...arguments);
        this.modifier = '.self';
    }
    /**
     * @param {?} element
     * @param {?} event
     * @param {?} handler
     * @return {?}
     */
    addEventListener(element, event, handler) {
        /** @type {?} */
        const wrapped = (/**
         * @param {?} event
         * @return {?}
         */
        (event) => {
            if (event.target === event.currentTarget) {
                handler(event);
            }
        });
        return this.manager.addEventListener(element, this.unwrap(event), wrapped);
    }
}
SelfEventPlugin.ɵfac = /*@__PURE__*/ function () { let ɵSelfEventPlugin_BaseFactory; return function SelfEventPlugin_Factory(t) { return (ɵSelfEventPlugin_BaseFactory || (ɵSelfEventPlugin_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(SelfEventPlugin)))(t || SelfEventPlugin); }; }();
SelfEventPlugin.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: SelfEventPlugin, factory: SelfEventPlugin.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelfEventPlugin, [{
        type: Injectable
    }], null, null); })();
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SelfEventPlugin.prototype.modifier;
}

/**
 * @fileoverview added by tsickle
 * Generated from: plugins/silent.plugin.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SilentEventPlugin extends AbstractEventPlugin {
    constructor() {
        super(...arguments);
        this.modifier = '.silent';
    }
    /**
     * @param {?} element
     * @param {?} event
     * @param {?} handler
     * @return {?}
     */
    addEventListener(element, event, handler) {
        return this.manager
            .getZone()
            .runOutsideAngular((/**
         * @return {?}
         */
        () => this.manager.addEventListener(element, this.unwrap(event), handler)));
    }
    /**
     * @param {?} element
     * @param {?} event
     * @param {?} handler
     * @return {?}
     */
    addGlobalEventListener(element, event, handler) {
        return this.manager
            .getZone()
            .runOutsideAngular((/**
         * @return {?}
         */
        () => this.manager.addGlobalEventListener(element, this.unwrap(event), handler)));
    }
}
SilentEventPlugin.ɵfac = /*@__PURE__*/ function () { let ɵSilentEventPlugin_BaseFactory; return function SilentEventPlugin_Factory(t) { return (ɵSilentEventPlugin_BaseFactory || (ɵSilentEventPlugin_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(SilentEventPlugin)))(t || SilentEventPlugin); }; }();
SilentEventPlugin.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: SilentEventPlugin, factory: SilentEventPlugin.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SilentEventPlugin, [{
        type: Injectable
    }], null, null); })();
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SilentEventPlugin.prototype.modifier;
}

/**
 * @fileoverview added by tsickle
 * Generated from: plugins/stop.plugin.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class StopEventPlugin extends AbstractEventPlugin {
    constructor() {
        super(...arguments);
        this.modifier = '.stop';
    }
    /**
     * @param {?} element
     * @param {?} event
     * @param {?} handler
     * @return {?}
     */
    addEventListener(element, event, handler) {
        /** @type {?} */
        const wrapped = (/**
         * @param {?} event
         * @return {?}
         */
        (event) => {
            event.stopPropagation();
            handler(event);
        });
        return this.manager.addEventListener(element, this.unwrap(event), wrapped);
    }
    /**
     * @param {?} element
     * @param {?} event
     * @param {?} handler
     * @return {?}
     */
    addGlobalEventListener(element, event, handler) {
        /** @type {?} */
        const wrapped = (/**
         * @param {?} event
         * @return {?}
         */
        (event) => {
            event.stopPropagation();
            handler(event);
        });
        return this.manager.addGlobalEventListener(element, this.unwrap(event), wrapped);
    }
}
StopEventPlugin.ɵfac = /*@__PURE__*/ function () { let ɵStopEventPlugin_BaseFactory; return function StopEventPlugin_Factory(t) { return (ɵStopEventPlugin_BaseFactory || (ɵStopEventPlugin_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(StopEventPlugin)))(t || StopEventPlugin); }; }();
StopEventPlugin.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: StopEventPlugin, factory: StopEventPlugin.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StopEventPlugin, [{
        type: Injectable
    }], null, null); })();
if (false) {
    /**
     * @type {?}
     * @protected
     */
    StopEventPlugin.prototype.modifier;
}

/**
 * @fileoverview added by tsickle
 * Generated from: plugins/zone.plugin.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * TODO: This will not be needed in Angular 10
 * when libraries are allowed to use Ivy renderer and markDirty becomes stable API
 */
class ZoneEventPlugin extends AbstractEventPlugin {
    constructor() {
        super(...arguments);
        this.modifier = '.init';
    }
    /**
     * @param {?} _element
     * @param {?} _event
     * @param {?} handler
     * @return {?}
     */
    addEventListener(_element, _event, handler) {
        return this.handle(handler);
    }
    /**
     * @param {?} _element
     * @param {?} _event
     * @param {?} handler
     * @return {?}
     */
    addGlobalEventListener(_element, _event, handler) {
        return this.handle(handler);
    }
    /**
     * @private
     * @param {?} handler
     * @return {?}
     */
    handle(handler) {
        /** @type {?} */
        const zone = this.manager.getZone();
        /** @type {?} */
        const subscription = zone.onStable.subscribe((/**
         * @return {?}
         */
        () => {
            subscription.unsubscribe();
            handler(zone);
        }));
        return (/**
         * @return {?}
         */
        () => { });
    }
}
ZoneEventPlugin.ɵfac = /*@__PURE__*/ function () { let ɵZoneEventPlugin_BaseFactory; return function ZoneEventPlugin_Factory(t) { return (ɵZoneEventPlugin_BaseFactory || (ɵZoneEventPlugin_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(ZoneEventPlugin)))(t || ZoneEventPlugin); }; }();
ZoneEventPlugin.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ZoneEventPlugin, factory: ZoneEventPlugin.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ZoneEventPlugin, [{
        type: Injectable
    }], null, null); })();
if (false) {
    /**
     * @type {?}
     * @protected
     */
    ZoneEventPlugin.prototype.modifier;
}

/**
 * @fileoverview added by tsickle
 * Generated from: constants/plugins.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const NG_EVENT_PLUGINS = [
    {
        provide: EVENT_MANAGER_PLUGINS,
        useClass: SilentEventPlugin,
        multi: true,
    },
    {
        provide: EVENT_MANAGER_PLUGINS,
        useClass: PreventEventPlugin,
        multi: true,
    },
    {
        provide: EVENT_MANAGER_PLUGINS,
        useClass: SelfEventPlugin,
        multi: true,
    },
    {
        provide: EVENT_MANAGER_PLUGINS,
        useClass: StopEventPlugin,
        multi: true,
    },
    {
        provide: EVENT_MANAGER_PLUGINS,
        useClass: ZoneEventPlugin,
        multi: true,
    },
    {
        provide: EVENT_MANAGER_PLUGINS,
        useClass: OptionsEventPlugin,
        multi: true,
    },
    {
        provide: EVENT_MANAGER_PLUGINS,
        useClass: BindEventPlugin,
        multi: true,
    },
];

/**
 * @fileoverview added by tsickle
 * Generated from: decorators/should-call.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * TODO: This will not be needed when markDirty becomes stable API
 * @template T
 * @param {?} predicate
 * @return {?}
 */
function shouldCall(predicate) {
    return (/**
     * @param {?} _
     * @param {?} key
     * @param {?} desc
     * @return {?}
     */
    (_, key, desc) => {
        const { value } = desc;
        desc.value = (/**
         * @this {?}
         * @param {...?} args
         * @return {?}
         */
        function (...args) {
            /** @type {?} */
            const zone = arguments[0];
            if (zone instanceof NgZone) {
                Object.defineProperty(this, key, {
                    /**
                     * @this {?}
                     * @param {...?} args
                     * @return {?}
                     */
                    value(...args) {
                        if (predicate.apply(this, args)) {
                            zone.run((/**
                             * @return {?}
                             */
                            () => {
                                value.apply(this, args);
                            }));
                        }
                    },
                });
            }
            else if (predicate.apply(this, args)) {
                value.apply(this, args);
            }
        });
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: types/predicate.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: utils/as-callable.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 * @param {?} a
 * @return {?}
 */
function asCallable(a) {
    return (/** @type {?} */ (a));
}

/**
 * @fileoverview added by tsickle
 * Generated from: module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// @dynamic
class EventPluginsModule {
    /**
     * @param {?} plugins
     */
    constructor(plugins) {
        console.assert(!(plugins[0] instanceof SilentEventPlugin) || EventPluginsModule.initialized, 'EventPluginsModule must come after BrowserModule in imports');
        EventPluginsModule.initialized = true;
    }
}
EventPluginsModule.ɵfac = function EventPluginsModule_Factory(t) { return new (t || EventPluginsModule)(ɵngcc0.ɵɵinject(EVENT_MANAGER_PLUGINS)); };
EventPluginsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: EventPluginsModule });
EventPluginsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: NG_EVENT_PLUGINS });
EventPluginsModule.initialized = false;
/** @nocollapse */
EventPluginsModule.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [EVENT_MANAGER_PLUGINS,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EventPluginsModule, [{
        type: NgModule,
        args: [{
                providers: NG_EVENT_PLUGINS
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [EVENT_MANAGER_PLUGINS]
            }] }]; }, null); })();
if (false) {
    /** @type {?} */
    EventPluginsModule.initialized;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: tinkoff-ng-event-plugins.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { BindEventPlugin, EventPluginsModule, NG_EVENT_PLUGINS, OptionsEventPlugin, PreventEventPlugin, SilentEventPlugin, StopEventPlugin, ZoneEventPlugin, asCallable, shouldCall, AbstractEventPlugin as ɵa, SelfEventPlugin as ɵb };

